import { render, staticRenderFns } from "./project1.vue?vue&type=template&id=09c424e5&scoped=true"
import script from "./project1.vue?vue&type=script&lang=js"
export * from "./project1.vue?vue&type=script&lang=js"
import style0 from "./project1.vue?vue&type=style&index=0&id=09c424e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c424e5",
  null
  
)

export default component.exports